import { Button, Flex, Heading, Icon, IconButton, Input, InputGroup, InputRightElement, Select, Spinner, Stack, Table, TableContainer, Tbody, Td, Text, Th, Thead, Tr, useToast } from "@chakra-ui/react";
import { useEffect, useState } from "react";

import { FaArrowLeft, FaArrowRight, FaSearch, FaSync } from "react-icons/fa";
import { RiFolder2Fill } from "react-icons/ri";
import { Link } from "react-router-dom";
import { GET } from "../../../utils/ApiRequestProvider";

interface DocumentsReviewItem {
    organization: string;
    status: string;
    remainingCredits: number;
    processingCredits: number;
    estimatedCredits: number;
    entityName: string;
    entityId: string;
    oldestDocElapsedTime: string;
    latestDocElapsedTime: string;
    elapsedLoginTime: string;
    pendingPurchaseInvoices: number;
    pendingSalesInvoices: number;
    pendingStatements: number;
    pendingSplittedDocuments: number;
    pendingDocuments: number;
    inProcess: number;
    businessId: number;
}

interface PaginationType {
    currentPage: number;
    totalPages: number;
    totalRecords: number;
}

export default function DocumentsReview() {
    const toast = useToast();
    const [loading, setLoading] = useState(false);
        const [paginationQuery, setPaginationQuery] = useState({ page: 1, pageSize: 5 });
    const [pagination, setPagination] = useState<PaginationType>({ currentPage: 0, totalPages: 0, totalRecords: 0 });
    const [documents, setDocuments] = useState<DocumentsReviewItem[]>([]);
    async function FetchList() {
        setLoading(true);
        try {
                        const res = await GET(`/api/Documents/Documentlist?page=${paginationQuery.page}&pageSize=${paginationQuery.pageSize}&status=${`Processing`}&sortColumn=Date&sortOrder=desc`);
            setPagination(res.data.pagination);
            setDocuments(res.data.documents);
        } catch (err) {
            toast({
                title: 'Something Went Wrong!',
                description: 'An unexpected error occured while proceeding your request!',
                status: 'error',
                isClosable: false,
                duration: 1000,
                position: 'top-right'
            });
        }
        setLoading(false);
    }

    useEffect(() => {
        FetchList();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [paginationQuery]);

    return (
        <Stack w={'full'} justify={"center"} align={"center"} spacing={6}>
            <Stack
                direction={{ base: 'column', md: 'column', lg: 'column', xl: 'row' }}
                justify={'space-between'}
                boxShadow={'base'}
                rounded={'xl'}
                w={'98%'}
                p={4}
                spacing={{ base: 6, md: 6, lg: 6, xl: 0 }}
            >
                <Stack
                    align={'flex-start'}
                    justify={'start'}
                    spacing={4}
                >
                    <Stack direction={'row'}>
                        <Icon
                            as={RiFolder2Fill}
                            fontSize={'5xl'}
                            color={'primary.400'}
                        />
                        <Stack spacing={1}>
                            <Heading fontSize={'xl'}>View All Entity List</Heading>
                            <Text fontSize={'sm'}>Here you can see all your entity list.</Text>
                        </Stack>
                    </Stack>
                </Stack>
                <Stack align={{ lg: 'flex-start', xl: 'flex-end' }} justify={'end'} spacing={4}>
                    <Stack direction={'row'}>
                        <InputGroup>
                            <Input placeholder='Search' />
                            <InputRightElement children={<FaSearch color={'#ababab'} />} />
                        </InputGroup>
                        <Select>
                            <option value="option1">All Entities</option>
                            <option value="option2">Default Entities</option>
                            <option value="option3">Test Entities</option>
                        </Select>
                        <IconButton
                            aria-label='Refresh'
                            rounded={'full'}
                            onClick={() => FetchList()}
                            icon={<FaSync />}
                        />
                    </Stack>
                </Stack>
            </Stack>

            <Stack boxShadow={'base'} rounded={'xl'} w={'98%'} p={4} spacing={4}>
                <TableContainer h={'sm'} overflowY={'scroll'}>
                    <Table size='sm'>
                        <Thead position={'sticky'} top={'0%'} zIndex={1} h={'50px'} bg={'primary.400'} alignItems={'flex-start'}>
                            <Tr>
                                <Th
                                    isNumeric
                                    color={"white"}
                                >
                                    Sr.
                                </Th>
                                <Th
                                    color={'white'}
                                >
                                    Organization
                                </Th>
                                <Th
                                    color={'white'}
                                >
                                    Status
                                </Th>
                                <Th
                                    color={'white'}
                                >
                                    Remaining Credits
                                </Th>
                                <Th
                                    color={'white'}
                                >
                                    Processing Credits
                                </Th>
                                <Th
                                    color={'white'}
                                >
                                    Estimated Credits
                                </Th>
                                <Th
                                    color={'white'}
                                >
                                    Entity Name
                                </Th>
                                <Th
                                    color={'white'}
                                >
                                    Oldest Doc Elapsed Time
                                </Th>
                                <Th
                                    color={'white'}
                                >
                                    Latest Doc Elapsed Time
                                </Th>
                                <Th
                                    color={'white'}
                                >
                                    Pending Purchase Invoices
                                </Th>
                                <Th
                                    color={'white'}
                                >
                                    Pending Sales Invoices
                                </Th>
                                <Th
                                    color={'white'}
                                >
                                    Pending Statements
                                </Th>
                                <Th
                                    color={'white'}
                                >
                                    Splitted Documents
                                </Th>
                                <Th
                                    color={'white'}
                                >
                                    Pending Other Documents
                                </Th>
                                <Th
                                    color={'white'}
                                >
                                    In Process
                                </Th>
                            </Tr>
                        </Thead>
                        <Tbody>
                            {
                                documents?.length > 0 ?
                                    (
                                        documents.map((inv, i) => (
                                            <Tr>
                                                <Td>{i + 1}</Td>
                                                <Td>{inv.organization}</Td>
                                                <Td>{inv.status}</Td>
                                                <Td>{inv.remainingCredits}</Td>
                                                <Td>{inv.processingCredits}</Td>
                                                <Td>{inv.estimatedCredits}</Td>
                                                <Td>{inv.entityName}</Td>
                                                <Td>{new Date(inv.oldestDocElapsedTime).toLocaleString()}</Td>
                                                <Td>{new Date(inv.latestDocElapsedTime).toLocaleString()}</Td>
                                                <Td>
                                                    <Button
                                                        as={Link}
                                                        to={`/internal/PurchaseDocuments/${inv.entityId}`}
                                                        w={'full'}
                                                        size={'sm'}
                                                        bg={'blue.400'}
                                                        color={'white'}
                                                        rounded={'none'}
                                                        _hover={{ bg: 'blue.500' }}
                                                        _active={{ bg: 'blue.600' }}
                                                    >
                                                        {inv.pendingPurchaseInvoices}
                                                    </Button>
                                                </Td>
                                                <Td>
                                                    <Button
                                                        as={Link}
                                                        w={'full'}
                                                        size={'sm'}
                                                        bg={'blue.400'}
                                                        color={'white'}
                                                        rounded={'none'}
                                                        _hover={{ bg: 'blue.500' }}
                                                        _active={{ bg: 'blue.600' }}
                                                        to={`/internal/SalesDocuments/${inv.entityId}`}
                                                    >
                                                        {inv.pendingSalesInvoices}
                                                    </Button>
                                                </Td>
                                                <Td>
                                                    <Button
                                                        as={Link}
                                                        w={'full'}
                                                        size={'sm'}
                                                        bg={'blue.400'}
                                                        color={'white'}
                                                        rounded={'none'}
                                                        _hover={{ bg: 'blue.500' }}
                                                        _active={{ bg: 'blue.600' }}
                                                        to={'/internal/bank-statements'}
                                                    >
                                                        {inv.pendingStatements}
                                                    </Button>
                                                </Td>
                                                <Td>
                                                    <Button
                                                        as={Link}
                                                        w={'full'}
                                                        size={'sm'}
                                                        bg={'blue.400'}
                                                        color={'white'}
                                                        rounded={'none'}
                                                        _hover={{ bg: 'blue.500' }}
                                                        _active={{ bg: 'blue.600' }}
                                                        to={"/internal/splitted-documents"}
                                                    >
                                                        {inv.pendingSplittedDocuments}
                                                    </Button>
                                                </Td>
                                                <Td>
                                                    <Button
                                                        as={Link}
                                                        w={'full'}
                                                        size={'sm'}
                                                        bg={'blue.400'}
                                                        color={'white'}
                                                        rounded={'none'}
                                                        _hover={{ bg: 'blue.500' }}
                                                        _active={{ bg: 'blue.600' }}
                                                        to={`/internal/other-documents/${inv.entityId}`}
                                                    >
                                                        {inv.pendingDocuments}
                                                    </Button>
                                                </Td>
                                                <Td>
                                                    <Button
                                                        as={Link}
                                                        w={'full'}
                                                        size={'sm'}
                                                        bg={'blue.400'}
                                                        color={'white'}
                                                        rounded={'none'}
                                                        _hover={{ bg: 'blue.500' }}
                                                        to={'/internal/in-process'}
                                                        _active={{ bg: 'blue.600' }}
                                                    >
                                                        {inv.inProcess}
                                                    </Button>
                                                </Td>
                                            </Tr>
                                        ))
                                    )
                                    :
                                    (
                                        loading ?
                                            (
                                                <Tr>
                                                    <Td colSpan={9}>
                                                        <Flex gap={2} justify={'center'} align={'center'}>
                                                            <Text>Loading</Text>
                                                            <Spinner size={'sm'} color={'primary.400'} />
                                                        </Flex>
                                                    </Td>
                                                </Tr>
                                            )
                                            :
                                            (
                                                <Tr>
                                                    <Td textAlign={'center'} colSpan={9}>No Data Available</Td>
                                                </Tr>
                                            )
                                    )
                            }
                        </Tbody>
                    </Table>
                </TableContainer>
                <Stack
                    direction={'row'}
                    justify={"space-between"}
                    align={'center'}
                >
                    <Text>Showing {documents?.length ?? 0} of {pagination.totalRecords} results</Text>
                    <Stack direction={'row'} spacing={4}>
                        <Select defaultValue={5} onChange={(e) => {
                            setPaginationQuery({ page: 1, pageSize: parseInt(e.target.value) });
                        }}>
                            <option value={5}>5 Per Page</option>
                            <option value={10}>10 Per Page</option>
                            <option value={25}>25 Per Page</option>
                            <option value={50}>50 Per Page</option>
                        </Select>
                        <Stack direction={'row'}>
                            <IconButton
                                aria-label="Previous"
                                icon={<FaArrowLeft />}
                                rounded={'full'}
                                disabled={pagination.currentPage <= 1}
                                onClick={() => setPaginationQuery({ ...paginationQuery, page: pagination.currentPage - 1 })}
                            />
                            <IconButton
                                aria-label="Previous"
                                icon={<FaArrowRight />}
                                rounded={'full'}
                                disabled={pagination.currentPage >= pagination.totalPages}
                                onClick={() => setPaginationQuery({ ...paginationQuery, page: pagination.currentPage + 1 })}
                            />
                        </Stack>
                    </Stack>
                </Stack>
            </Stack>
        </Stack >
    )
}